module.exports = __webpack_public_path__ + "static/media/right.fadb2b0d.png";